import { render, staticRenderFns } from "./applySpendMoney.vue?vue&type=template&id=65baa0d9&scoped=true&"
import script from "./applySpendMoney.vue?vue&type=script&lang=js&"
export * from "./applySpendMoney.vue?vue&type=script&lang=js&"
import style0 from "./applySpendMoney.vue?vue&type=style&index=0&id=65baa0d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baa0d9",
  null
  
)

export default component.exports